<template>
    <div class="contracts-layout">
      <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'ContractsLayout',
}
</script>
